import Component from 'flarum/Component';
import LinkButton from 'flarum/components/LinkButton';
import Link from 'flarum/components/Link';

export default class AboutTeamMember extends Component {
  view() {
    return [
      <div className={'Site-About-Header content-box'}>
        <div className={'About-section-info'}>
          <h2>Chúng tôi là Khát Vọng Sống 👋</h2>
          <p>
          Khát Vọng Sống(KhatVongSong) là cộng đồng nói tiếng Việt dành cho các nhà phát triển. Một cộng đồng trẻ đầy ý tưởng, sáng tạo và nỗ lực. KhatVongSong cung cấp cho các thành viên khả năng đặt câu hỏi, viết hướng dẫn hoặc tổ chức giới thiệu về dự án của họ cho các thành viên khác.
          </p>
        </div>
        <div className={'About-section-buttons'}>
          <LinkButton href={'/p/4-quy-dinh'} className={'Button'} icon={'fas fa-hands-helping'}>
            Nội quy
          </LinkButton>
          <LinkButton href={'/p/8-privacy-policy'} className={'Button'} icon={'fas fa-blind'}>
            Riêng tư
          </LinkButton>
          <LinkButton href={'/p/16-cookie-consent'} className={'Button'} icon={'fas fa-cookie'}>
            Lưu trữ
          </LinkButton>

          <div className={'about-socials'}>
            <a href={'#'} target={'_blank'} title={'Follow us on LinkedIn'} className={'Button linkedin'}>
              <i className={'fab fa-linkedin'} />
            </a>
            <a href={'#'} target={'_blank'} title={'Follow us on Twitter'} className={'Button twitter'}>
              <i className={'fab fa-twitter'} />
            </a>
            <a href={'#'} target={'_blank'} title={'KVS Discord server'} className={'Button discord'}>
              <i className={'fab fa-discord'} />
            </a>
            <Link href={'#'} title={'$100 gratis DigitalOcean tegoed'} className={'Button digital-ocean'}>
              <i className={'fab fa-digital-ocean'} />
            </Link>
          </div>
        </div>
      </div>,

      <div className={'TabsContainer'}>
        <Link href={'/over'} className={`TabButton${this.attrs.selected === 'about' ? ' TabButton--active' : ''}`}>
          <span>Thống kê</span>
        </Link>
        <Link href={'/over/team'} className={`TabButton${this.attrs.selected === 'team' ? ' TabButton--active' : ''}`}>
          <span>Đội ngũ</span>
        </Link>
        <Link href={'/over/history'} className={`TabButton${this.attrs.selected === 'history' ? ' TabButton--active' : ''}`}>
          <span>Lịch sử</span>
        </Link>
        <Link href={'/over/partners'} className={`TabButton${this.attrs.selected === 'partners' ? ' TabButton--active' : ''}`}>
          <span>Đối tác</span>
        </Link>
      </div>,
    ];
  }
}
